<template>
  <v-container class='input-text-size'>
    <MonthlyBalanceCriteria/>
      <CRUDList
        ref="crudList"
        :canAdd="false"
        :headers='headers'
        :displayTopPagination="false"
        :canEdit="true"
        :canSave="true"
        :showDate="true"
        :showTotal="true"
        :baseCrudKey="baseCrudKey"
        @loadCRUDList="handleLoadCrudList"
        :selectedItems="selectedItems"
        @emitSelectedItem="emitSelectedItem"
        @upsertItem="upsrtTransaction"
        tableWrapperDynamicClassname='elevation-3 ma-3 pa-3 taxroll-table-wrapper'
        tableDynamicClassname='taxroll-custom-table'
        tableDynamicHeight='250'

        :defaultSortBy="sortBy"
        :showSelect="false"
        >
        </CRUDList>
       <v-row  dense align="center" justify="center">
        <v-col cols='3' class='pt-4'>
                <v-btn color="primary" dense small >
                            Print Monthly Balancing Report
                          </v-btn>
              </v-col>
       </v-row>

      </v-container>
  </template>

<script>
import {
  mapMutations, mapActions, mapState, mapGetters,
} from 'vuex';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import MonthlyBalanceCriteria from './monthlyBalanceCriteria.vue';

export default {
  name: 'MonthlyBalanceTransactionList',
  data() {
    return {
      headers: [
        { text: 'Tax Year', value: 'taxYear' },
        { text: 'Tax District', value: 'schoolDistrict' },
        { text: 'Begining Uncollected ', value: 'approvalStatusForVisibility' },
        { text: 'Supplements ', value: 'auditSummary' },
        { text: 'Adjustments ', value: 'auditSummary' },
        { text: 'Payments ', value: 'auditSummary' },
        { text: 'Ending Uncollected ', value: 'auditSummary' },
        { text: 'Original Tax Roll ', value: 'auditSummary' },
        { text: '% Collected ', value: 'auditSummary' },
        { text: 'Over-Collected ', value: 'auditSummary' },
        { text: 'Held in Protest', value: 'auditSummary' },
      ],

      baseCrudKey: 'monthlyBalanceTransaction',

      sortBy: [
        {
          column: 'taxYear',
          direction: 'desc',
        },
      ],

    };
  },
  components: {
    CRUDList,
    MonthlyBalanceCriteria,

  },
  created() {
    // this.initCriteria();
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'item',
    ]),
    ...mapState({
      storeSelItems: (state) => state.tax.taxPayment.selectedItems,
      wkstNumList: (state) => state.tax.taxPayment.wkstNumList || [],

    }),
    selectedItems: {
      get() {
        return this.storeSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },

  },
  methods: {

    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setCriteria']),

    ...mapMutations('tax/taxPayment', [
      'setSelectedItems',
    ]),
    ...mapActions('tax/taxPayment', [
      'loadWkstnList',
    ]),

    async handleLoadCrudList() {
      // manageGridLoading(this, true, 'Searching...');

      // const { baseCrudKey } = this;
      // const criteria = {
      //   // paymentAuditRecord: 'yes',

      //   ...this.criteriaState,
      // };
      // await this.loadPaymentAuditRecords({
      //   criteria,
      //   baseCrudKey,
      //   postProcessTrans: this.postProcessData,
      // }).then(() => {
      //   this.setDefaultSelectedItems();
      // }).finally(() => {
      //   manageGridLoading(this, false);
      // });
    },
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.selectedItems = [];
      });
    },
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    async upsrtTransaction() {
      // const updatedauditRecordItem = { ...item };
      // delete updatedauditRecordItem.approvalStatusForVisibility;
      // const response = await this.upsertTaxPaymentAudit({
      //   item: updatedauditRecordItem,
      //   baseCrudKey: this.baseCrudKey,
      // }).then(() => {
      //   this.handleAuditRecords();
      // });
      // return response;
    },

  },

};
</script>
